<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="searchBar">
        <el-form-item label="SN">
          <el-input v-model.trim="tableData.search.sn" clearable></el-input>
        </el-form-item>
        <el-form-item label="LAN口MAC">
          <el-input v-model.trim="tableData.search.lan_mac" clearable></el-input>
        </el-form-item>
        <el-form-item label="WAN口MAC">
          <el-input v-model.trim="tableData.search.wan_mac" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model.trim="tableData.search.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="自定义型号">
          <el-input v-model.trim="tableData.search.model_x" clearable></el-input>
        </el-form-item>
      </template>
    </vue-table>
  </div>
</template>

<script>
import {commonChanger,oemType} from "@utils/formatList"
export default {
  name: "index",
  data() {
    return {
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "设备型号", property: "model"},
          {label: "SN", property: "sn", width: 200},
          {label: "应用识别", property: "app_ident", width: 80, format: commonChanger},
          {label: "平台", property: "plat"},
          {label: "授权主机数", property: "host_num"},
          {label: "最大WAN口数", property: "wan_num"},
          {label: "到期时间", property: "expire_at"},
          {label: "LAN口MAC", property: "lan_mac"},
          {label: "WAN口MAC", property: "wan_mac"},
          {label: "OEM", property: "oem", format: oemType},
          {label: "备注", property: "remark"},
        ],
        hasExpand: true,
        expandColumn: [
          {label: "ID", property: "id"},
          {label: "SN", property: "sn"},
          {label: "设备型号", property: "model"},
          {label: "自定义型号", property: "model_x"},
          {label: "应用识别", property: "app_ident", format: commonChanger},
          {label: "自定义应用识别", property: "app_ident_x", format: commonChanger},
          {label: "授权主机数", property: "host_num"},
          {label: "自定义主机数", property: "host_num_x"},
          {label: "最大WAN口数", property: "wan_num"},
          {label: "自定义WAN口数", property: "wan_num_x"},
          {label: "到期时间", property: "expire_at"},
          {label: "自定义到期时间", property: "expire_at_x"},
          {label: "创建时间", property: "create_at"},
          {label: "更新时间", property: "update_at"},
          {label: "平台", property: "plat"},
          {label: "OEM", property: "oem", format: oemType},
          {label: "备注", property: "remark"},
          {label: "LAN口MAC", property: "lan_mac"},
          {label: "WAN口MAC", property: "wan_mac"},
        ],
        api: "getDeviceList",
        search: {
          sn: "",
          lan_mac: "",
          wan_mac: "",
          model: "",
          model_x: "",
        },
      },
    }
  },
  methods: {
    getTableList() {
      this.$refs["tableRef"].refresh();
    },
  },
}
</script>

<style scoped>

</style>